import { Component, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DocSubmitTypeEnum } from "app/model/entities/enums";
import { JoHeader } from "app/model/entities/jo-header";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";
import { UnitOfWork } from "app/shared/unit-of-work";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-jo-info",
  templateUrl: "./jo-info.component.html",

  standalone: false,
})
export class JobOrderInfoComponent extends DomainBaseComponent {
  @Input() entity: JoHeader;

  constructor(
    public uow: UnitOfWork,
    protected domainService: DomainService,
    protected route: ActivatedRoute
  ) {
    super(domainService);

    this.route.paramMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  get invoiceDeliveryLabel(): string {
    const typeId = this.entity?.account?.invoiceDocSubmitTypeId;
    if (typeId == null) return '';
    switch (typeId) {
      case DocSubmitTypeEnum.Print: return 'Print';
      case DocSubmitTypeEnum.Email: return 'Email';
      case DocSubmitTypeEnum.PrintAndEmail: return 'Print and Email';
      case DocSubmitTypeEnum.None: return 'None';
      default: return '';
    }
  }

  async updateFromContext() {}
}
